import {
  SUBMIT_CREATE_BENCHMARK_REQUEST,
  SUBMIT_CREATE_BENCHMARK_SUCCESS,
  SUBMIT_CREATE_BENCHMARK_FAILURE,
} from "../actions/createBenchmarkActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const createBenchmarkReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_CREATE_BENCHMARK_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case SUBMIT_CREATE_BENCHMARK_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case SUBMIT_CREATE_BENCHMARK_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default createBenchmarkReducer;
